<script setup lang="ts">
import type { JSX } from '@ionic/core'

withDefaults(defineProps<JSX.IonLoading & {
	message?: string
	isOpen: boolean
}>(), {
	message: 'Bitte warten...',
})
</script>

<template>
	<ion-loading
		class="accessible-loading"
		:message="message"
		:is-open="isOpen"
	/>
</template>
